var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgLightIcnShare18 = function SvgLightIcnShare18(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 18,
    height: 18,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    stroke: "currentColor",
    strokeLinecap: "round",
    d: "M5.078 7.889H3.3a1 1 0 0 0-1 1v6.333a1 1 0 0 0 1 1h11.333a1 1 0 0 0 1-1V8.89a1 1 0 0 0-1-1h-1.777"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "M6.189 4.278 8.967 1.5m0 0 2.777 2.778M8.967 1.5v9.444"
  })));
};
export default SvgLightIcnShare18;